var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquifaxSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1534 828",
    width: 1534,
    height: 828,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "equifax_150_28-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #9e1c33 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m316.9 357.8l-29.6 136h316.9l-26.7 133.1h-577.4l142.1-626.9h559.7l-26.7 127.2h-307.9l-23.7 106.4h269.5l-26.7 124.2zm823.2 0l393.8 470.2h-260.6l-171.7-201.1c0 0-65.2 20.7-168.8 17.8-103.6-6-296.1 0-287.2-180.4 5.9-88.7 35.5-204.1 35.5-204.1 56.3-221.8 210.2-221.8 390.9-215.8 124.3 2.9 319.8 2.9 284.2 198.1 0 0-8.9 56.2-20.7 115.3zm-97.7-207c-88.8-5.9-121.4 76.9-121.4 76.9-38.5 112.4-53.3 212.9-53.3 212.9-14.8 73.9 41.4 100.6 91.8 100.6 44.4 0 103.6-26.7 121.4-76.9 38.5-106.5 53.3-212.9 53.3-212.9 20.7-118.3-91.8-100.6-91.8-100.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquifaxSmall);
export default __webpack_public_path__ + "static/media/equifax_small.0f1420c9b48a8a22febdc5cdf2b0ab4d.svg";
export { ForwardRef as ReactComponent };